import { configureStore } from '@reduxjs/toolkit';

import { equipmentSliceReducer } from '@/entities/equipment/model/equipment.slice';
import { exerciseSliceReducer } from '@/entities/exercise/model/exercise.slice';
import { exerciseSearchSliceReducer } from '@/entities/exercise/model/exercise-search.slice';
import { localeSliceReducer } from '@/entities/locale/model/locale.slice';
import { metricSliceReducer } from '@/entities/metrics/model/metric.slice';
import { movementSliceReducer } from '@/entities/movement/model/movement.slice';
import { movementMuscleSliceReducer } from '@/entities/movement-muscle/model/movement-muscle.slice';
import { muscleSliceReducer } from '@/entities/muscle/model/muscle.slice';
import { sectionPlanSliceReducer } from '@/entities/section-plan/model/section-plan.slice';
import { setPlanSliceReducer } from '@/entities/set-plan/model/set-plan.slice';
import { stepPlanSliceReducer } from '@/entities/step-plan/model/step-plan.slice';
import { workoutPlanSliceReducer } from '@/entities/workout-plan/model/workout-plan.slice';
import { workoutCreatorSliceReducer } from '@/features/workout-creator/model/workoutCreator.slice';

const store = configureStore({
	reducer: {
		// Entities (normalized data)
		metrics: metricSliceReducer,
		exercises: exerciseSliceReducer,
		equipments: equipmentSliceReducer,
		locales: localeSliceReducer,
		movements: movementSliceReducer,
		muscles: muscleSliceReducer,
		movementMuscles: movementMuscleSliceReducer,
		stepPlans: stepPlanSliceReducer,
		sectionPlans: sectionPlanSliceReducer,
		setPlans: setPlanSliceReducer,
		workoutPlans: workoutPlanSliceReducer,

		// Features (UI state)
		exerciseSearch: exerciseSearchSliceReducer,
		workoutCreator: workoutCreatorSliceReducer,
	},
});

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;
type AppStore = typeof store;

export type { AppDispatch, AppStore, RootState };
export { store };
